import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace UpdateMfaStatusUnenroll {
  export type Input = void;
  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();

    const updateMfaUnenroll = useInjectFeApiContext(
      FeApi.usersV1MfaUnenrollDestroy,
    );
    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(): Promise<Output> {
        await ok(updateMfaUnenroll({}));
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['me'],
        });
      },
    });
  }
}
